module.exports = __webpack_public_path__ + "img/物流仓储.468ad9be.png";